<template>
  <div class="expert-pagination-container">
    <div class="expert-page" v-for="(page, pageIndex) in paginatedExperts" :key="pageIndex"
      :style="{ display: currentPage === pageIndex ? 'grid' : 'none' }">
      <div class="expert-item" v-for="(expert, index) in page" :key="index">
        <div class="expert-avatar">
          <!-- 测试 -->
          <!-- <img src="https://randomuser.me/api/portraits/men/4.jpg" :alt="expert.title"> -->
          <!-- 正式 -->
          <img :src="imgUrl?.url+expert.cover" :alt="expert.title">
        </div>
        <div class="expert-info">
          <h3 class="expert-name">{{ expert.title }}</h3>
          <p class="expert-desc">{{ expert.intro }}</p>
        </div>
      </div>
    </div>
    <button v-if="paginatedExperts.length > 1" class="scroll-button prev" @click="prevPage"
      :disabled="currentPage === 0">
      ‹
    </button>
    <button v-if="paginatedExperts.length > 1" class="scroll-button next" @click="nextPage"
      :disabled="currentPage === paginatedExperts.length - 1">
      ›
    </button>

  </div>
</template>

<script>
  export default {
    name: 'ExpertPagination',
    props: {
      imgUrl: {
        type: Object,
        default: {}, // 默认空数组
      },
      experts: {
        type: Array,
        required: true,
        default: () => [], // 默认空数组
        validator: value => {
          return value.every(expert => {
            return 'title' in expert && 'cover' in expert && 'intro' in expert
          })
        }
      },
    },

    data() {
      return {
        currentPage: 0,
        expertsPerPage: 8
      }
    },
    computed: {
      paginatedExperts() {
        const pages = []
        for (let i = 0; i < this.experts.length; i += this.expertsPerPage) {
          pages.push(this.experts.slice(i, i + this.expertsPerPage))
        }
        return pages
      }
    },
    methods: {
      prevPage() {
        if (this.currentPage > 0) {
          this.currentPage--
        }
      },
      nextPage() {
        if (this.currentPage < this.paginatedExperts.length - 1) {
          this.currentPage++
        }
      }
    }
  }
</script>

<style scoped>
  .expert-pagination-container {
    position: relative;
    width: 100%;
    margin: 0 auto;
    padding: 0 3vw;
  }

  .expert-page {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 1vw;
    margin-bottom: 1vw;
  }

  .expert-item {
    background: #fff;
    /* border-radius: 8px; */
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding: 1.5vw;
    display: flex;
    transition: transform 0.2s ease;
  }

  .expert-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  }

  .expert-avatar {
    flex: 0 0 5vw;
    height: 5vw;
    margin-right: 2vw;
  }

  .expert-avatar img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }

  .expert-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
  }

  .expert-name {
    margin: 0 0 0.5vw 0;
    font-size: 1.4rem;
    color: #333;
    font-weight: bold;
  }

  .expert-desc {
    margin: 0;
    font-size: 1rem;
    color: #666;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .scroll-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: white;
    border: 1px solid #e0e0e0;
    font-size: 20px;
    cursor: pointer;
    z-index: 10;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease;
  }

  .scroll-button:hover {
    background: #f5f5f5;
  }

  .scroll-button:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  .prev {
    left: 0;
  }

  .next {
    right: 0;
  }


  /* .pagination-controls {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-top: 20px;
  } */

  /*  .pagination-controls button {
    padding: 8px 16px;
    background: #f0f0f0;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background 0.2s ease;
  }

  .pagination-controls button:hover {
    background: #e0e0e0;
  }

  .pagination-controls button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .pagination-controls span {
    font-size: 14px;
    color: #666;
  } */

  @media (max-width: 1024px) {
    .expert-page {
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(4, 1fr);
    }
  }

  @media (max-width: 768px) {
    .expert-page {
      grid-template-columns: 1fr;
      gap: 15px;
    }

    .expert-item {
      padding: 12px;
    }

    .expert-avatar {
      flex: 0 0 50px;
      height: 50px;
      margin-right: 12px;
    }

    .expert-name {
      font-size: 15px;
    }

    .expert-desc {
      font-size: 13px;
      -webkit-line-clamp: 2;
    }
  }
</style>
